function Footer() {
  return (
    <footer style={{ textAlign: "center", padding: "20px" }}>
      <p>© Worshippers Unite</p>
    </footer>
  );
}

export default Footer;